<template>
   <el-container class="content" style="display: block;">
     <div >
       <img @click="goHome()"  :src="require('@/assets/image/goback.png')" style="position: absolute;left: 0;top: 0;z-index: 1008;opacity: 0.8;" :style="{'height':screenHeight*0.03+'px'}" >
     </div>
     <div style="position: fixed;z-index: 1005;background-color: #000;z-index: 1005;bottom: 0;"  :style="{'width':screenHeight*0.5+'px','height':screenHeight*0.3+'px','right':(screenWidth-screenHeight*0.5)/2+'px'}" >
       <video width="100%" height="100%" ref="videoPlayer" @ended="restartVideo" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo1" v-if="ishows">
         <source :src="index_url" type="video/mp4">

       </video>
     </div>
     <div :style="{'margin-top': '11px','width': '110%','height':'120%','margin-left': -(width/2+5)+'px','margin-top': -(width/1.3)+'px'}" @wheel="handleWheel">
       <div class="bordered-box">
         <div class="gradient-border" @click="show(item['id'])" :style="{'box-shadow': '-1px 0 2px '+listq[index]['yellow']+', 0 1px 2px '+listq[index]['blue']+', 1px 0 2px '+listq[index]['orange']+', 0 -1px 2px '+listq[index]['red'],'width': width+'px','height': height+'px','margin-left':isShifted(index) ? (width/2+5)+'px' : '3px','margin-top':-width*0.1+'px'}" v-for="(item, index) in list1" :key="index">
           
           <img v-show="!item['t']"  :src="require('@/assets/image/zhanwei1.png')" class="imgs">
           <img v-show="item['t']"  :src="item['img']" class="imgs" v-on:error="onImageError" @load="loadImg(index)">


         </div>
       </div>


     </div>







     <div :class="{'overlay':isOpen,'overlay1':!isOpen}" v-if="isOpen" @click="hides()" >

         <!-- <img  :src="require('@/assets/image/'+bigImg)" class="imgs"> -->
         <img  :src="bigImg" class="imgs" v-on:error="onImageError" style="object-fit: contain;">

     </div>
     <div class="beian">

      <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


     </div>
   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        cshow:false,
        cshow1:false,
        cshow2:false,
        cshow3:false,
        isOpen: false,
        bigImg:'',
        list:[],
        list1:[],
        listq:[],
        listz:[],
        blue:'rgba(0, 0, 255, 1)',
        yellow:'rgba(255, 255, 0, 1)',
        orange:'rgba(255, 165, 0, 1)',
        red:'rgba(255, 0, 0, 1)',

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        width:(window.innerWidth*1.1-30*3-((window.innerWidth*1.1-30*3)/30)/1.9)/30,
        height:(window.innerWidth*1.1-30*3-((window.innerWidth*1.1-30*3)/30)/1.9)/30,
        scrollUp: 0,
        scrollDown: 0,
        wnum:30,
        shows_id:0,
        cli:false,
        clir:false,
        clio:false,
        id:this.$route.query.id,
        index_url:'https://video.universepower.cn/yuzhouzhimi/universepower_hunshayuzhou_zhiyeren_jinshasha_video3.mp4',
        ishows:false
      };
    },
    mounted() {
        // document.addEventListener('click', () => {
        //       if (this.isOpen) {
        //         this.isOpen = false;
        //       }
        //     });
        // 监听滚轮事件
        document.addEventListener('wheel', this.preventScroll, { passive: false });
      },
      beforeDestroy() {
        // 移除事件监听
        document.removeEventListener('wheel', this.preventScroll);
        document.removeEventListener('click', () => {});
      },
    created() {

      //   this.images.push('./static/imgs/ali_0'+i+'.png')
      // window.oncontextmenu = function () { return false; };
      // window.onselectstart = function () { return false; };
      // window.onkeydown = window.onkeyup = window.onkeypress = function () {
      //     window.event.returnValue = false;
      //     return false;
      // }
      this.loadings()
      this.getScreen()
      this.loadList()

      this.startAnimation()


    },

	methods:{
    isShifted(index) {
      return Math.floor(index / this.wnum) % 2 === 0 && index % this.wnum === 0;
    },
    goHome() {

      this.$router.push('/');
    },
    restartVideo() {
      this.$refs.videoPlayer.currentTime = 0;
      this.$refs.videoPlayer.play();
    },
    opens(url){


      this.ishows = false
      this.index_url = ""
      setTimeout(() => {
        this.ishows = true
        this.index_url = url

        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
          }
        });
      }, 200);

    },
    cshows(){
      this.cshow = !this.cshow
      if(!this.cshow){
        this.cshow1 = false
        this.cshow2 = false
        this.cshow3 = false
      }

    },
    cshows1(){
      this.cshow1 = !this.cshow1
      if(this.cshow1){
        this.cshow2 = false
        this.cshow3 = false
      }
    },
    cshows2(){
      this.cshow2 = !this.cshow2
      if(this.cshow2){
        this.cshow1 = false
        this.cshow3 = false
      }
    },
    cshows3(){
      this.cshow3 = !this.cshow3
      if(this.cshow3){
        this.cshow1 = false
        this.cshow2 = false
      }
    },
    goshipin(){
      this.$router.push('/shop');
    },
    toPage(name){
      this.$router.push('/'+name);
    },
    toHome(command) {
      this.$router.push('/');
    },
    vchangeo(e){
      var elements = document.querySelectorAll(".popper__arrow");
      elements.forEach(function(element) {
        element.style.display = 'none';

      });
      if(e){
        this.clio = true
      }else{
        this.clio = false
      }
    },
    test(){
      setTimeout(()=>{
        var elements = document.querySelectorAll(".popper__arrow");
        elements.forEach(function(element) {


          element.style.display = 'none';
          // element.remove()
        });
      },10)

    },
    vchangel(e){

      if(e){
        this.cli = true
        var elements = document.querySelectorAll(".popper__arrow");
        elements.forEach(function(element) {

          element.style.display = 'none';
          // element.remove()
        });
      }else{
        this.cli = false
      }
    },
    vchanger(e){
      var elements = document.querySelectorAll(".popper__arrow");
      elements.forEach(function(element) {
        element.style.display = 'none';

      });
      if(e){
        this.clir = true
      }else{
        this.clir = false
      }
    },
    handleCommand(command) {
      this.$router.push('/'+command);
    },
    loadImg(index){
      var items = this.list1[index]
      this.$set(this.list1, index, {'id':items['id'],'name':items['name'],'img':items['img'],'imgs':items['imgs'],'t_id':items['t_id'],'t':true});
    },
    loadings(){
      this.wnum = 30
      if(window.innerWidth == 2048){
        this.wnum = 29
      }
      if(window.innerWidth == 1920){
        this.wnum = 24
      }
      if(window.innerWidth == 1856){
        this.wnum = 25
      }
      if(window.innerWidth == 1792){
        this.wnum = 23
      }
      if(window.innerWidth == 1680){
        this.wnum = 21
      }
      if(window.innerWidth == 1600){
        this.wnum = 20
      }
      if(window.innerWidth == 1440){
        this.wnum = 19
      }
      if(window.innerWidth == 1400){
        this.wnum = 18
      }
      if(window.innerWidth == 1366 || window.innerWidth == 1360){
        this.wnum = 18
      }
      if(window.innerWidth == 1280){
        this.wnum = 18
      }
      if(window.innerWidth == 1152){
        this.wnum = 16
      }
      if(window.innerWidth == 1024){
        this.wnum = 14
      }
      if(window.innerWidth == 800){
        this.wnum = 12
      }
      
      this.width = (window.innerWidth*1.1-this.wnum*3-((window.innerWidth*1.1-this.wnum*3)/this.wnum)/1.9)/this.wnum
      this.height = (window.innerWidth*1.1-this.wnum*3-((window.innerWidth*1.1-this.wnum*3)/this.wnum)/1.9)/this.wnum
    },

    onImageError(event){
      event.target.src = require('@/assets/image/zhanwei.png');
    },
    getScreen() {
      if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i )){
        window.location.href='http://m.universe.top/shouyet?id='+this.id

      }

    },
    handleWheel(event) {
          const delta = event.deltaY;
          if (delta > 0) {
            // 向上滚动
            var olds = []
            var news = []
            var that = this
            var nums = that.list.length-that.wnum-1
            // console.log(nums,'nums')
            this.list.forEach(function(item, index) {
              if(index>nums){
                news.push(item)
                // that.list.splice(index, 1);
              }
            })
            that.list.splice(nums, that.wnum);
            // console.log(that.list.length,'news')

            this.list1.forEach(function(item, index) {
              if(index < that.wnum){
                olds.push(item)
                that.list1.splice(index, 1);
              }
            })
            olds.forEach(function(item, index) {
              that.list.unshift(item)

            })
            news.forEach(function(item, index) {
              that.list1.push({'id':item['id'],'name':item['name'],'img':item['img'],'t_id':item['t_id']})
            })
            // console.log(that.list1.length,'olds')
            // console.log(that.list1.length,'list1')

          } else if (delta < 0) {
            // 向下滚动

            var olds = []
            var news = []
            var that = this
            var nums = that.list.length-that.wnum-1
            this.list.forEach(function(item, index) {
              if(index < that.wnum){
                // console.log(item,'new')

                news.push(item)
                that.list.splice(index, 1);
              }
            })
            this.list1.forEach(function(item, index) {
              if(index>nums){
                olds.push(item)
              }
            })
           that.list1.splice(nums, that.wnum);
            olds.forEach(function(item, index) {
              that.list.push(item)
            })
            news.forEach(function(item, index) {
              that.list1.unshift({'id':item['id'],'name':item['name'],'img':item['img'],'t_id':item['t_id']})
            })

          }
        },
    // show(index,imgs){
    //   this.listz = imgs
    //   this.isOpen = true
    //   var bigImgs = this.listz

    //   var img = bigImgs[Math.floor(Math.random() * bigImgs.length)]
    //   this.bigImg = img

    // },
    showc(id,ids){
      if(this.isOpen && this.shows_id == id){
        this.show(ids)
      }
    },
    show(id){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:id

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/loadShouyeBIgImg'
      })
      .then(res=>{
        this.listz = res.data.data;
        this.shows_id = id
        this.isOpen = true
        var bigImgs = this.listz
        var img = bigImgs[Math.floor(Math.random() * bigImgs.length)]
        this.bigImg = img
      })
      .catch(err=>{

      });


    },
    hides(){
      this.isOpen = false
    },

    preventScroll(event) {
          // 阻止滚轮事件
      event.preventDefault();
    },

        startAnimation(m,n) {
          var that = this

          this.interval1 = setInterval(() => {
            if(that.isOpen){
              var bigImgs = that.listz

              var img = bigImgs[Math.floor(Math.random() * bigImgs.length)]
              that.bigImg = img
              that.$forceUpdate()

              console.log(that.bigImg)
            }


          }, 8000);
          this.interval2 = setInterval(() => {

            that.listq.forEach(function(item, index) {
              var blue = 'rgba('+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+',1)'
              var yellow = 'rgba('+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', 1)'
              var orange = 'rgba('+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', 1)'
              var red = 'rgba('+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', 1)'
              if(item['num']<item['nums']){
                that.$set(that.listq, index, {'blue':blue,'yellow':yellow,'orange':orange,'red':red,'num':item['num']+1,'nums':item['nums']});
              }else{
                // console.log(index,'替换')
                var tt = Math.floor(Math.random() * that.list.length)
                var items = that.list[tt]
                var old = that.list1[index]

                that.showc(that.list1[index]['id'],items['id'])
                that.$set(that.list1, index, {'id':items['id'],'name':items['name'],'img':items['img'],'t':true,'t_id':item['t_id']});
                that.$set(that.list, tt, old);
                that.$set(that.listq, index, {'blue':blue,'yellow':yellow,'orange':orange,'red':red,'num':0,'nums':item['nums'],'t_id':item['t_id']});
              }

            })

          }, 200);

        },

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,
          id:this.id

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/loadGuanwangShouye'
      })
      .then(res=>{
        this.list = res.data.data;
        this.list1 = res.data.data1;
        this.listq = res.data.dataq;
        this.listz = res.data.dataz;
        this.index_url = res.data.index_url;
        this.opens(this.index_url)
      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
  .cdaohang{
    background-color: #000000;
  }
  ul li:hover{
    background-color: #cacaca;
  }
  .el-dropdown-menu__item{
    color: #ffffff;
    font-weight: bold;
    font-family: guanwangdaohang;
  }
  .popper__arrow{
    display: none;
  }
  .daohangclicolor{
    color: #cacaca;
  }
  .daohangnocolor{
    color: #ffffff;
  }
.daohangcli{
  height: 50px;
  border: #00b4ff 1px solid;
  width: 350px;
  border-radius: 50px;
  background-color: #001d31;
}
.daohangno{
  height: 50px;
  border: #686868 1px solid;
  width: 350px;
  border-radius: 50px;
  background-color: #0071e3;
}
  .daohangw{
    position: fixed;
    z-index: 1000;
    left: 40%;
    top:0%;

  }
  .beian {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }
  .overlaydis{

    display: none;
  }
  .overlay {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }
  .el-main{
    height: 1800px;
  }
  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }
  .bordered-box{
     overflow-wrap: break-word;
     display: flex;
     flex-wrap: wrap;
     background-color: #000;
     /* margin-left: 20px; */
  }
.lefts{
  margin-left: 75px;
}
.rights{
  margin-right: 75px;
}
.gradient-border {
      /* float: left; */
      display: flex;
      /* margin-left: 5px; */
      /* margin-top: -9px; */
	    position: relative;
	    /* width: 76px;
	    height: 76px; */
	    background: #fff;
	    border-radius: 50%;
	    overflow: hidden;
      /* margin:20px auto; */
      /* box-shadow: -1px 0 3px yellow, 0 1px 3px blue, 1px 0 3px orange, 0 -1px 3px red; */
      background-color: black;
	  }


	.imgs{
    position: absolute;
		width: 80%;
		height: 80%;
    object-fit: contain;
		left: 10%;
		top:10%;
	}

.daohangcliz{
    height: 50px;
    border: #00b4ff 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #001d31;
  }
  .daohangnoz{
    height: 50px;
    border: #686868 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #0071e3;
  }



</style>



// WEBPACK FOOTER //
// src/components/main/shouyet.vue